var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from "react";
import { useGateValue } from "@statsig/react-bindings";
import { getAllPartnerWabaStates, isMessagingBffConfigured } from "@/api/messaging/messaging";
import { SAFE_MODE_GATE } from "@/utilities/safeMode/safeMode";
import useErrorHandler from "@/utilities/hooks/useErrorHandler";
/**
 * WABAs under a partner whose outbound marketing is currently paused.
 *
 * Fetches GET /partner/{id} ONCE and derives the blocked set from the returned
 * list. It never calls the single-WABA endpoint per row - a 50-row channels
 * list must produce one request, not 50.
 *
 * The effect deliberately keys on [available, partnerId] only. The channels
 * list refetches its table on every filter/sort change; keying off that would
 * re-hit the BFF each time a user types in the search box.
 */
var usePartnerBlockedWabas = function (partnerId) {
    var handleError = useErrorHandler();
    var isGateOn = useGateValue(SAFE_MODE_GATE);
    var available = Boolean(isGateOn && isMessagingBffConfigured && partnerId);
    var _a = __read(React.useState([]), 2), blockedWabaIds = _a[0], setBlockedWabaIds = _a[1];
    React.useEffect(function () {
        if (!available || !partnerId)
            return;
        var cancelled = false;
        var read = function () { return __awaiter(void 0, void 0, void 0, function () {
            var states, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getAllPartnerWabaStates({ partnerId: partnerId })];
                    case 1:
                        states = _a.sent();
                        if (cancelled)
                            return [2 /*return*/];
                        setBlockedWabaIds(states
                            .filter(function (state) { return state.isMarketingBlocked; })
                            .map(function (s) { return s.wabaId; }));
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        // Suppressed: a failed read must never be presented as "nothing is
                        // blocked" via a toast. Track it and render no banner.
                        if (!cancelled) {
                            handleError(err_1, null, "Reading partner WABA marketing states failed");
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        read();
        return function () {
            cancelled = true;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [available, partnerId]);
    return { blockedCount: blockedWabaIds.length, blockedWabaIds: blockedWabaIds, available: available };
};
export default usePartnerBlockedWabas;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlUGFydG5lckJsb2NrZWRXYWJhcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInVzZVBhcnRuZXJCbG9ja2VkV2FiYXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLE9BQU8sS0FBSyxLQUFLLE1BQU0sT0FBTyxDQUFDO0FBQy9CLE9BQU8sRUFBRSxZQUFZLEVBQUUsTUFBTSx5QkFBeUIsQ0FBQztBQUV2RCxPQUFPLEVBQ0wsdUJBQXVCLEVBQ3ZCLHdCQUF3QixFQUN6QixNQUFNLDJCQUEyQixDQUFDO0FBQ25DLE9BQU8sRUFBRSxjQUFjLEVBQUUsTUFBTSwrQkFBK0IsQ0FBQztBQUMvRCxPQUFPLGVBQWUsTUFBTSxtQ0FBbUMsQ0FBQztBQUVoRTs7Ozs7Ozs7OztHQVVHO0FBQ0gsSUFBTSxzQkFBc0IsR0FBRyxVQUFDLFNBQWtCO0lBQ2hELElBQU0sV0FBVyxHQUFHLGVBQWUsRUFBRSxDQUFDO0lBQ3RDLElBQU0sUUFBUSxHQUFHLFlBQVksQ0FBQyxjQUFjLENBQUMsQ0FBQztJQUU5QyxJQUFNLFNBQVMsR0FBRyxPQUFPLENBQUMsUUFBUSxJQUFJLHdCQUF3QixJQUFJLFNBQVMsQ0FBQyxDQUFDO0lBRXZFLElBQUEsS0FBQSxPQUFzQyxLQUFLLENBQUMsUUFBUSxDQUFXLEVBQUUsQ0FBQyxJQUFBLEVBQWpFLGNBQWMsUUFBQSxFQUFFLGlCQUFpQixRQUFnQyxDQUFDO0lBRXpFLEtBQUssQ0FBQyxTQUFTLENBQUM7UUFDZCxJQUFJLENBQUMsU0FBUyxJQUFJLENBQUMsU0FBUztZQUFFLE9BQU87UUFFckMsSUFBSSxTQUFTLEdBQUcsS0FBSyxDQUFDO1FBRXRCLElBQU0sSUFBSSxHQUFHOzs7Ozs7d0JBRU0scUJBQU0sdUJBQXVCLENBQUMsRUFBRSxTQUFTLFdBQUEsRUFBRSxDQUFDLEVBQUE7O3dCQUFyRCxNQUFNLEdBQUcsU0FBNEM7d0JBQzNELElBQUksU0FBUzs0QkFBRSxzQkFBTzt3QkFFdEIsaUJBQWlCLENBQ2YsTUFBTTs2QkFDSCxNQUFNLENBQUMsVUFBQyxLQUFLLElBQUssT0FBQSxLQUFLLENBQUMsa0JBQWtCLEVBQXhCLENBQXdCLENBQUM7NkJBQzNDLEdBQUcsQ0FBQyxVQUFDLENBQUMsSUFBSyxPQUFBLENBQUMsQ0FBQyxNQUFNLEVBQVIsQ0FBUSxDQUFDLENBQ3hCLENBQUM7Ozs7d0JBRUYsbUVBQW1FO3dCQUNuRSx1REFBdUQ7d0JBQ3ZELElBQUksQ0FBQyxTQUFTLEVBQUU7NEJBQ2QsV0FBVyxDQUNULEtBQUcsRUFDSCxJQUFJLEVBQ0osOENBQThDLENBQy9DLENBQUM7eUJBQ0g7Ozs7O2FBRUosQ0FBQztRQUVGLElBQUksRUFBRSxDQUFDO1FBRVAsT0FBTztZQUNMLFNBQVMsR0FBRyxJQUFJLENBQUM7UUFDbkIsQ0FBQyxDQUFDO1FBQ0YsdURBQXVEO0lBQ3pELENBQUMsRUFBRSxDQUFDLFNBQVMsRUFBRSxTQUFTLENBQUMsQ0FBQyxDQUFDO0lBRTNCLE9BQU8sRUFBRSxZQUFZLEVBQUUsY0FBYyxDQUFDLE1BQU0sRUFBRSxjQUFjLGdCQUFBLEVBQUUsU0FBUyxXQUFBLEVBQUUsQ0FBQztBQUM1RSxDQUFDLENBQUM7QUFFRixlQUFlLHNCQUFzQixDQUFDIn0=